import { AciklamaeklePage } from './../../Yonetim/aciklamaekle/aciklamaekle';
import { Ortak } from './../../../providers/ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { BllOrtak } from '../../../providers/bll/bll-ortak';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';

/**
 * Generated class for the AciklamaListePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-aciklama-liste',
  templateUrl: 'aciklama-liste.html',
})
export class AciklamaListePage {
  aranan="";
skip:number=0;
take:number=100;
AksesuarListesi=[];

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public modalCtrl:ModalController,

     public navParams: NavParams) {
  }

  ionViewDidLoad() {
   this.kayitAra(null);

  }
  kayitAra(e) {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "AksesuarListesi","", false).then(a => {
     
      var sonuc = <any>a;
      this.AksesuarListesi = sonuc.SonucObject;
   
   
 
    })
  }
  
  durumkayitlari(e) {

    if (e.keyCode == 13) {
      this.kayitAra(e);
    }
  }
  yenikayit() {
    let modal = this.modalCtrl.create(AciklamaeklePage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();

  }
  kayitduzenle(aciklama){
    let modal = this.modalCtrl.create(AciklamaeklePage, { isVw: aciklama });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
   
  }
  DurumSil(aciklama) {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      
      formData.append("ID", aciklama.ID);

      this.bllOrtak.islem(formData, "AciklamaSil", "", true).then(a => {

      }).catch(x => {

        this.ortak.showErrorAlert();
      })
      this.kayitAra("");
     
    })
   
  }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/aciklama-liste/aciklama-liste.ts